module.exports = __webpack_public_path__ + "img/miscelanea_flechita_naranja.a9a26ee1.svg";